"use client";

declare global {
  interface Window {
    unifiedTrackingFactory?: () => UnifiedTrackingInstance;
  }
}

interface UnifiedTrackingInstance {
  trackScreenView: (screenName?: string, eventData?: Record<string, any>) => UnifiedTrackingInstance;
}

class UBETracking {
  private instance: UnifiedTrackingInstance | null = null;
  private queue: Array<() => void> = [];
  private isReady = false;
  private initialized = false;

  constructor() {
    if (typeof window !== "undefined") {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => this.initialize(), { once: true });
      } else {
        // Defer initialization to ensure all scripts have loaded
        setTimeout(() => this.initialize(), 0);
      }
    }
  }

  private initialize() {
    if (this.initialized) return;
    this.initialized = true;

    if (window.unifiedTrackingFactory) {
      this.instance = window.unifiedTrackingFactory();
      this.isReady = true;
      this.flushQueue();
    } else {
      window.addEventListener("UnifiedTrackingReady", () => {
        if (window.unifiedTrackingFactory) {
          this.instance = window.unifiedTrackingFactory();
          this.isReady = true;
          this.flushQueue();
        }
      }, { once: true });
    }
  }

  private flushQueue() {
    while (this.queue.length > 0) {
      const fn = this.queue.shift();
      fn?.();
    }
  }

  trackScreenView(screenName: string, eventData?: Record<string, any>) {
    const track = () => {
      if (typeof window !== "undefined") {
        window.dispatchEvent(
          new CustomEvent("unified-library-track-screen-view", {
            detail: {
              screenNameStandard: screenName,
              eventData: eventData || {},
            },
          })
        );
      }
    };

    if (this.isReady) {
      track();
    } else {
      this.queue.push(track);
    }
  }
}

export const ubeTracking = new UBETracking();